import styled, { css } from 'styled-components'

import theme from '../../utils/theme'

const IconWrapper = styled.svg.withConfig({
  shouldForwardProp: prop => !['hoverColor'].includes(prop),
})`
  width: 32px;
  height: 32px;
  fill: none;

  ${props => css`
    &:hover > path:nth-of-type(1),
    &:hover > path:nth-of-type(2) {
      fill: ${props.hoverColor};
    }
  `}
`

const NoNotificationsIcon = ({ themeMode, hasNotification }) => {
  return (
    <IconWrapper
      hoverColor={
        themeMode === 'light' ? theme.mainNav.topBarIconColorHover : theme.mainNav.topBarIconColorHoverDarkMode
      }
      xmlns="http://www.w3.org/2000/svg"
      alt="Notifications Icon"
    >
      {hasNotification ? (
        <path
          d="M21.8079 17.4098C21.6307 17.0632 21.52 16.6516 21.52 16.2617V15.027C21.365 15.0486 21.2322 15.0486 21.0772 15.0486C18.4423 15.0486 16.2946 12.9474 16.2946 10.348C16.2946 9.39483 16.5824 8.50668 17.0917 7.74851C16.9367 6.88203 16.1617 6.21051 15.2318 6.21051C14.169 6.21051 13.3276 7.05533 13.3276 8.07344V8.2684C10.7813 9.04824 8.92139 11.3661 8.92139 14.0955V16.24C8.92139 16.6516 8.83282 17.0415 8.63354 17.3881L7.10576 20.3991C6.95077 20.6807 6.97291 21.0273 7.12791 21.2873C7.30504 21.5689 7.61502 21.7205 7.92501 21.7205H22.5164C22.8264 21.7205 23.1364 21.5472 23.2914 21.2873C23.4685 21.0273 23.4685 20.6807 23.3357 20.3991L21.8079 17.4098Z"
          fill={themeMode === 'light' ? theme.colors.darkGrey : theme.colors.darkModeGrey}
        />
      ) : (
        <path
          d="M12 6C10.8 6 9.8 6.9 9.8 8.1V8.3C7.1 9.1 5.2 11.4 5.2 14.1V16.3C5.2 16.7 5.1 17.1 4.9 17.4L3.4 20.4C3.3 20.7 3.4 21 3.6 21.2C3.8 21.5 4.1 21.7 4.4 21.7H19.6C19.9 21.7 20.2 21.5 20.4 21.2C20.6 21 20.6 20.7 20.5 20.4L19 17.4C18.8 17.1 18.7 16.7 18.7 16.3V14.1C18.7 11.4 16.8 9.1 14.1 8.3V8.1C14.1 6.9 13.1 6 12 6Z"
          fill={themeMode === 'light' ? theme.colors.darkGrey : theme.colors.darkModeGrey}
          transform="translate(3, 0)"
        />
      )}

      <path
        d="M15.2099 26.7894C17.0477 26.7894 18.5533 25.338 18.5533 23.5184H11.8887C11.8887 25.338 13.3722 26.7894 15.2099 26.7894Z"
        fill={themeMode === 'light' ? theme.colors.darkGrey : theme.colors.darkModeGrey}
      />
      {hasNotification && (
        <path
          d="M21.0772 13.2074C22.6914 13.2074 24 11.9272 24 10.348C24 8.76878 22.6914 7.48859 21.0772 7.48859C19.4631 7.48859 18.1545 8.76878 18.1545 10.348C18.1545 11.9272 19.4631 13.2074 21.0772 13.2074Z"
          fill={theme.colors.teal}
        />
      )}
    </IconWrapper>
  )
}

export default NoNotificationsIcon
